module.exports = __webpack_public_path__ + "static/media/9.d6307f28.jpg";